<template>
  <v-app id="tat">
    <ui-modal></ui-modal>
    <router-view/>
  </v-app>
</template>

<script>
  import UiModal from "./plugins/gx-ui/components/UiModal";

  export default {
    name: 'App',
    components: {UiModal},
    data: () => ({
      //
    }),
  };
</script>

<style>
.red-border {
  border: 1px solid red;
}
</style>
